export const eventDefaults = {
  ife: {
    event: 'ife-interaction',
    eventCategory: `Immersive Form Interaction`,
  },
  ifeSimulator: {
    event: 'evcSimulator-interaction',
    eventCategory: `simulatorInteraction`,
  },
  navigation: {
    event: 'navigation-interaction',
    eventCategory: 'Navigation',
    component: {
      name: 'Navigation',
    },
  },
  footer: {
    event: 'footer-interaction',
    eventCategory: 'Navigation',
    component: {
      name: 'Footer',
    },
  },
};
